import { Enum_Environment } from '@/views/Main/MainBean';
import { defineStore } from 'pinia';
export const EnvironmentStore = defineStore({
  id: 'workEnvironment', // id必填
  state: () => {
    return {
      Environment: Enum_Environment.IntelligentWarning
    }
  }
})